module.exports = __webpack_public_path__ + "static/media/CarryOn_HandLaggage_Arrows.079a0233.glb";